import React, { Component } from 'react';
import Slider from 'react-slick';
import './slick.css'
import './slickSlider.css'

class SlickSlider extends Component {

  constructor(props) {
    super()
    this.props = props
  }

  randomNum = () => {
    return Math.random();
  }

  next = () => {
    this.refs.slider.slickNext()
  }

  previous = () => {
    this.refs.slider.slickPrev()
  }

  render() {
    const settings = {
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1 ,
      centerMode: true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
    };
    return (
      <div className="slickSlider-wrapper">
        <Slider ref="slider" {...settings}>
          {
            this.props.gallery.map(function(image) {
              return(
                <div className="image--slickSlider-wrapper" key={this.randomNum()}><img src={image.url}  className="image image--slickSlider"/></div>
              )  
            }.bind(this))
          } 
        </Slider>
        <div className="slickSlider-button--wrapper">
          <button className="button slickSlider-button slickSlider-button--prev" onClick={this.previous}>Previous</button>
          <button className="button slickSlider-button slickSlider-button--next" onClick={this.next}>Next</button>
        </div>
      </div>   
    )
  }
}

export default SlickSlider;


/** WEBPACK FOOTER **
 ** ./src/js/components/slick-slider/index.js
 **/